/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Single discount applied to an order entry by the pricing engine.
 * @export
 * @interface SAPAppliedDiscount
 */
export interface SAPAppliedDiscount {
    /**
     * Unique identifier of the discount within the enclosing line item or additional cost value.
     * @type {string}
     * @memberof SAPAppliedDiscount
     */
    code?: string;
    /**
     * Field for grouping/classifying multiple discounts, mainly for discount summary display.
     * @type {string}
     * @memberof SAPAppliedDiscount
     */
    group?: string;
    /**
     * Related coupon code, if applicable.
     * @type {string}
     * @memberof SAPAppliedDiscount
     */
    couponCode?: string;
    /**
     * Amount by which the product price is reduced due to this discount.
     * @type {number}
     * @memberof SAPAppliedDiscount
     */
    value?: number;
    /**
     * Optional specification indicating that the discount applies to one specific unit within the overall product quantity of the line item. Does not change the line item product price, but may affect taxes in some countries or jurisdictions.
     * @type {number}
     * @memberof SAPAppliedDiscount
     */
    proRateUnitNr?: number;
}

/**
 * Check if a given object implements the SAPAppliedDiscount interface.
 */
export function instanceOfSAPAppliedDiscount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SAPAppliedDiscountFromJSON(json: any): SAPAppliedDiscount {
    return SAPAppliedDiscountFromJSONTyped(json, false);
}

export function SAPAppliedDiscountFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPAppliedDiscount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'group': !exists(json, 'group') ? undefined : json['group'],
        'couponCode': !exists(json, 'couponCode') ? undefined : json['couponCode'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'proRateUnitNr': !exists(json, 'proRateUnitNr') ? undefined : json['proRateUnitNr'],
    };
}

export function SAPAppliedDiscountToJSON(value?: SAPAppliedDiscount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'group': value.group,
        'couponCode': value.couponCode,
        'value': value.value,
        'proRateUnitNr': value.proRateUnitNr,
    };
}

